<template>
    <filterable @loading="changeLoading" ref="filter" v-bind="filterable">
        <thead slot="thead">
            <tr>
                <th>{{$t('attributes.name')}}</th>
                <th>{{$t('attributes.document')}}</th>
                <th>E-mail</th>
                <th>Telefone</th>
            </tr>
        </thead>
        <tr slot-scope="{item}">
            <td>
                <p-check v-model="selecionados" :value="item" :color="appLayout.check"
                    class="p-default p-curve p-thick p-smooth">{{item.nome}}</p-check>
            </td>
            <td>{{item.documento}}</td>
            <td>{{item.email}}</td>
            <td>{{item.telefone}}</td>
        </tr>
    </filterable>
</template>
<script>
    export default {
        props: {
            selected: []
        },
        data() {
            return {
                selecionados: [],
                filterable: {
                    disableAutoGet: true,
                    deleted: false,
                    storeAction: 'setSignatarios',
                    storeName: 'signatario.data',
                    model: 'signatario',
                    url: '/api/signatarios',
                },
            }
        },
        watch: {
            selecionados(data) {
                this.selected.length = 0;
                data.map(payload => {
                    let item = {
                        assinatura_nome: payload.nome,
                        assinatura_email: payload.email,
                        assinatura_documento: payload.documento,
                        assinatura_telefone: payload.telefone,
                        assinatura_tipo: '1',
                        token_tipo: 'E',
                        ordem: 1,
                    }
                    this.selected.push(item);
                });
            }
        },
        methods: {
            fetchData() {
                this.$refs.filter.fetch();
            }
        }
    }
</script>